export default __webpack_public_path__ + "media/images/ui-icons_777777_256x240-fef4dc5a79a6117235d7ed374987a212.png";